module.exports = __webpack_public_path__ + "img/lv12.45bef89a.png";